import React from 'react'
import { Box, IconButton, Tooltip } from '@mui/material'
import { useAppTheme } from '@/theme/ThemeContext'

type Props = {
  icon: string
  alt: string
  onClick?: () => void
  sx?: any
}

const MapHeaderIcon: React.FC<Props> = ({ icon, alt, onClick, sx }) => {
  const { mode } = useAppTheme()
  const isDarkMode = mode === 'dark'

  const colors = {
    bg: isDarkMode ? '#0F1B2E' : '#FFFFFF',
    border: isDarkMode ? 'rgba(255,255,255,0.10)' : 'rgba(50,59,119,0.10)',
    hoverBg: isDarkMode ? '#13233B' : '#F3F6FB',
    glow: isDarkMode ? '0 0 0 3px rgba(115, 145, 255, 0.08)' : '0 0 0 3px rgba(0, 130, 200, 0.08)',
    iconFilter: isDarkMode ? 'brightness(0) invert(1)' : 'none',
  }

  return (
    <Tooltip title={alt} arrow>
      <IconButton
        onClick={onClick}
        sx={{
          width: 'clamp(32px, 2.5vw, 48px)',
          height: 'clamp(32px, 2.5vw, 48px)',
          borderRadius: 'clamp(6px, 0.5vw, 8px)',
          backgroundColor: colors.bg,
          border: `1px solid ${colors.border}`,
          boxShadow: isDarkMode ? '0 4px 12px rgba(0,0,0,0.25)' : '0 3px 8px rgba(13, 75, 120, 0.08)',
          transition: 'all 0.2s ease',
          '&:hover': {
            backgroundColor: colors.hoverBg,
            boxShadow: `${colors.glow}, ${isDarkMode ? '0 6px 16px rgba(0,0,0,0.35)' : '0 5px 12px rgba(13, 75, 120, 0.10)'}`,
          },
          ...sx
        }}
      >
        <Box
          component="img"
          src={icon}
          alt={alt}
          sx={{
            width: 'clamp(15px, 1.15vw, 22px)',
            height: 'clamp(15px, 1.15vw, 22px)',
            filter: colors.iconFilter,
          }}
        />
      </IconButton>
    </Tooltip>
  )
}

export default MapHeaderIcon
